module.exports = __webpack_public_path__ + "static/media/play_btn.5bc804d0.png";